import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, useContext, useState } from "react";
const useFormStatus = () => {
  const $ = _c(2);
  const [isLoading, setLoading] = useState(false);
  let t0;
  if ($[0] !== isLoading) {
    t0 = {
      isLoading,
      setLoading
    };
    $[0] = isLoading;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export const FormStatusContext = createContext({} as ReturnType<typeof useFormStatus>);
export const useFormStatusContext = () => {
  return useContext(FormStatusContext);
};
export function FormStatusProvider(props) {
  const $ = _c(3);
  const t0 = useFormStatus();
  let t1;
  if ($[0] !== props.children || $[1] !== t0) {
    t1 = <FormStatusContext.Provider value={t0}>{props.children}</FormStatusContext.Provider>;
    $[0] = props.children;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}